import { useQuery } from '@tanstack/react-query'
import { getProfileUser } from '../services/MyProfile'
import { TAGS } from '../services/Tags'
import { OUT_OF_THE_APP } from '../utils/constants'
import { useGlobalProfileUserInfo } from '../store'
import { useEffect } from 'react'

export const useGetProfileUserInfo = () => {
  const { setProfileInfo } = useGlobalProfileUserInfo()

  const {
    data = {},
    isLoading,
    isError,
  } = useQuery([TAGS.profile_data], getProfileUser, {
    enabled: !OUT_OF_THE_APP,
    staleTime: Infinity, // Los datos NUNCA se consideran obsoletos
    gcTime: Infinity, // Mantener en cache indefinidamente
    refetchOnMount: false, // NO refetch al montar componentes
    refetchOnWindowFocus: false, // NO refetch al enfocar la ventana
    refetchOnReconnect: false, // NO refetch al reconectar
  })

  useEffect(() => {
    if (data && Object.keys(data).length > 0) {
      setProfileInfo(data)
    }
  }, [data])

  return { data, isLoading, isError }
}
